export default {"src":"/_next/static/media/QMS.dbbe6c46.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};